import React, {useCallback} from "react";
import {useHistory, useParams} from "react-router-dom";
import useFetch from "@common/hooks/fetch/useFetch";
import {Moments} from "@common/utils/date/moments";
import {getAdGlobalDetail} from "@common/services/restapi/forum";
import Prev from "../../assets/image/icon_prev.svg";
import ReactPlayer from "react-player";
import {LazyLoadImage} from 'react-lazy-load-image-component';
import Global from "@common/enums/Global.enums";
import {isEmpty} from '@common/utils/common-utils'

function GlobalCreativeDetail() {
  const history = useHistory();
  const {forumType, ukey} = useParams();

  const {data: globalDetail} = useFetch(() => getAdGlobalDetail(forumType, ukey), [], {});

  const handleGoBack = useCallback(() => {
    history.goBack();
  }, []);

  return (
    <>
      <div className="common-header--top">
        <a className="prev-btn" onClick={handleGoBack}>
          <img src={Prev} alt=""/>
        </a>
        <h3 className="header-title">글로벌 크리에이티브 상세</h3>
      </div>

      <section className="common-body--list">
        <div className="global-list-big">
          {
            !isEmpty(globalDetail) &&
              <>
                {
                  Global.text.enumKey === forumType &&
                  <>
                    <div className="thumbnail-list">
                      <div className="title">{globalDetail.article.title}</div>
                      <div className="row-box">
                        <div className="left-box">
                          <div className="publisher">{globalDetail.article.writerId}</div>
                        </div>
                        <div className="right-box">
                          <div className="created-date">{Moments.Format(globalDetail.article.wdate, 'yyyy.MM.DD')}</div>
                        </div>
                      </div>
                    </div>
                    <p className="contents" dangerouslySetInnerHTML={{ __html: globalDetail.article.content }}/>
                  </>
                }
                {
                  Global.video.enumKey === forumType &&
                  <>
                    <div className="thumbnail-list">
                      <ReactPlayer
                        className='react-player'
                        url={globalDetail.article.contentPath}    // 플레이어 url
                        width='100%'         // 플레이어 크기 (가로)
                        height='100%'        // 플레이어 크기 (세로)
                        playing={true}        // 자동 재생 on
                        muted={true}          // 자동 재생 on
                        controls={true}       // 플레이어 컨트롤 노출 여부
                        light={false}         // 플레이어 모드
                        pip={true}            // pip 모드 설정 여부
                        poster={`${globalDetail.article.thumbnail.replace('/l/', '/m/')}`}   // 플레이어 초기 포스터 사진
                        config={{ file: {
                            attributes: {
                              controlsList: 'nodownload'  // 다운로드 방지
                            }
                          }}}
                        onEnded={() => handleVideo()}  // 플레이어 끝났을 때 이벤트
                      />
                      <div className="title">{globalDetail.article.title}</div>
                      <div className="row-box">
                        <div className="left-box">
                          <div className="publisher">{globalDetail.article.writerId}</div>
                        </div>
                        <div className="right-box">
                          <div className="created-date">{Moments.Format(globalDetail.article.wdate, 'yyyy.MM.DD')}</div>
                        </div>
                      </div>
                    </div>
                    <p className="contents">{globalDetail.article.content}</p>
                  </>
                }
              </>
          }
        </div>
      </section>
    </>
  )
}

export default GlobalCreativeDetail
